import { isDefined, Mutable, NotificationIdentifier } from '@evorait/pace-core';
import { on } from '@ngrx/store';
import { ContentResults } from '../../../types/content-results';
import { FormIdentifier } from '../../../types/form-identifier';
import { FormParticipantCopies } from '../../../types/form-participant-copies';
import { FormsConstants } from '../../../types/forms-constants';
import { initialParticipantCopyState, ParticipantCopy } from '../../../types/participant-copy';
import { ODataSPQModel } from '../../../types/service-part-questionnaire';
import {
    loadSpqDocSuccess,
    updateDefectServicePartIdentificationField,
    UpdateDefectServicePartIdentificationProps,
} from '../../actions/questionnaire.actions';
import { FormState } from '../../state/form.state';

export function loadSpqDocSuccessReducer(
    state: Readonly<FormState>,
    props: {
        form: FormIdentifier;
        questionnaire: ODataSPQModel;
        notification: NotificationIdentifier;
        language: string;
        contentResults: ContentResults;
        materialKey: string;
        lockedBy: string;
        xml: string;
        email: string;
        materialNumber: string;
    },
): Readonly<FormState> {
    const formMaster: ParticipantCopy = {
        ...initialParticipantCopyState,
        firstName: 'Master',
        lastName: 'Checklist',
        email: props.email,
        id: FormsConstants.MASTER_PARTICIPANT_ID,
        answers: props.contentResults.answers,
        customerIdentification: props.contentResults.customerIdentification,
        defectServicePartIdentification: props.contentResults.defectServicePartIdentification,
        functionalElements: props.contentResults.functionalElements,
        options: props.contentResults.options,
        hasCopy: true,
        xml: props.xml,
    };

    const participantCopies: Mutable<FormParticipantCopies> = {
        master: formMaster,
    };

    return {
        ...state,
        formId: props.form,
        notification: props.notification,
        type: <FormsConstants.FORMTYPE>props.questionnaire.Type,
        title: props.questionnaire.Title,
        language: props.language,
        variant: props.questionnaire.Variante,
        content: props.contentResults.contentBlocks,
        systemCondition: props.contentResults.systemCondition,
        hintsForFilling: props.contentResults.hintsForFilling,
        checkpoints: props.contentResults.checkpoints,
        checkpointDependencies: props.contentResults.checkpointDependencies,
        optionDependencies: props.contentResults.optionDependencies,
        headings: props.contentResults.headings,
        doctype: props.contentResults.doctype,
        infoClass: props.contentResults.infoClass,
        orgData: props.contentResults.orgData,
        copyright: props.contentResults.copyright,
        instructions: props.contentResults.instructions,
        typeFilters: props.contentResults.typeFilters,
        materialKey: props.materialKey,
        lockedBy: props.lockedBy,
        participantCopies,
        isLoading: false,
        errorDuringLoading: false,
        loadingStatus: FormsConstants.FORM_LOADING_STATUS.LOADED,
    };
}

export function updateDefectServicePartIdentificationFieldReducer(
    state: Readonly<FormState>,
    props: UpdateDefectServicePartIdentificationProps,
): Readonly<FormState> {
    const formMaster = state.participantCopies[FormsConstants.MASTER_PARTICIPANT_ID];
    const defectServicePartIdentification = formMaster.defectServicePartIdentification;
    let newDefectServicePartIdentification;
    if (isDefined(defectServicePartIdentification)) {
        if (props.xmlId === defectServicePartIdentification.materialNo.xmlId) {
            newDefectServicePartIdentification = {
                ...defectServicePartIdentification,
                materialNo: {
                    ...defectServicePartIdentification.materialNo,
                    value: props.newValue,
                },
            };
        }
        if (props.xmlId === defectServicePartIdentification.serialNo.xmlId) {
            newDefectServicePartIdentification = {
                ...defectServicePartIdentification,
                serialNo: {
                    ...defectServicePartIdentification.serialNo,
                    value: props.newValue,
                },
            };
        }
        if (props.xmlId === defectServicePartIdentification.orderNo.xmlId) {
            newDefectServicePartIdentification = {
                ...defectServicePartIdentification,
                orderNo: {
                    ...defectServicePartIdentification.orderNo,
                    value: props.newValue,
                },
            };
        }
    }

    const updatedMasterForm: ParticipantCopy = {
        ...formMaster,
        defectServicePartIdentification: newDefectServicePartIdentification,
    };

    return {
        ...state,
        participantCopies: {
            master: updatedMasterForm,
        },
    };
}

export const spqReducer = [
    on<FormState, Array<typeof loadSpqDocSuccess>>(loadSpqDocSuccess, loadSpqDocSuccessReducer),
    on<FormState, Array<typeof updateDefectServicePartIdentificationField>>(
        updateDefectServicePartIdentificationField,
        updateDefectServicePartIdentificationFieldReducer,
    ),
];
